import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { findIndex } from 'lodash-es';
import { UnsavedWorkTimeShiftUserGroupUser, WorkTimeShiftUserGroupUserListItem } from '@app/_models/work-time/work-time-shift-user-group';

@Injectable({
  providedIn: 'root'
})
export class WorkTimeShiftUserGroupUsersUiService {

  private unsavedUsersSource2 = new BehaviorSubject<UnsavedWorkTimeShiftUserGroupUser[]>([]);
  public unsavedUsers2 = this.unsavedUsersSource2.asObservable();

  constructor() { }

  setUnsavedUsersValue(value: UnsavedWorkTimeShiftUserGroupUser[]) {
    this.unsavedUsersSource2.next(value);
  }

  getUnsavedUsersValue(): UnsavedWorkTimeShiftUserGroupUser[] {
    return this.unsavedUsersSource2.getValue();
  }

  removeUserFromUnsavedUsers(userId: number) {
    const arr = this.getUnsavedUsersValue();
    const index = findIndex(arr, (item) => { return item.userAccountId === userId });
    if (index > -1) {
      arr.length === 1 ? arr.pop() : arr.splice(index, 1);
      this.setUnsavedUsersValue(arr);
    }
  }
}
